var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpAndDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18.000001",
    fill: "none",
    id: "svg211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs215"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 13.359535,7.2823424 C 13.321344,7.6610948 12.920733,8.0329216 12.533363,7.858905 12.261205,7.6995204 12.07038,7.4341086 11.838007,7.2233129 10.882683,6.2679861 9.9273592,5.3126592 8.9720352,4.3573324 7.8319205,5.4948579 6.6968718,6.6376931 5.5535842,7.7718933 5.2186674,8.0846881 4.6246738,7.7844349 4.6407858,7.3385925 4.648283,6.9876959 4.9857125,6.8030293 5.1913076,6.5630704 6.3160213,5.4400546 7.4373877,4.3135863 8.5641953,3.1927304 8.8376615,2.9262102 9.2999994,2.9622858 9.5486749,3.2464758 10.781462,4.4792656 12.014248,5.712054 13.247035,6.9448424 c 0.136124,0.030926 0.102067,0.2347834 0.1125,0.3375 z",
    fill: "#0051bd",
    id: "path104",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4.6404647,10.717658 c 0.038191,-0.378753 0.4388023,-0.7505796 0.8261719,-0.576563 0.2721586,0.159385 0.4629831,0.424796 0.6953562,0.635592 0.955324,0.955327 1.910648,1.910654 2.8659719,2.865981 1.1401153,-1.137526 2.2751633,-2.280361 3.4184513,-3.414561 0.334917,-0.3127951 0.92891,-0.01254 0.912798,0.4333 -0.0075,0.350897 -0.344926,0.535564 -0.550521,0.775523 -1.124714,1.123015 -2.246081,2.249484 -3.3728883,3.37034 -0.2734663,0.26652 -0.7358042,0.230444 -0.9844796,-0.05375 -1.2327868,-1.23279 -2.4655735,-2.465578 -3.6983604,-3.698366 -0.1361233,-0.03093 -0.1020668,-0.234784 -0.1125,-0.3375 z",
    fill: "#0051bd",
    id: "path104-4",
    style: {
      display: "inline"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpAndDownArrow);
export default __webpack_public_path__ + "static/media/upAndDownArrow.7f47896e3aa4f0a57572d4fb1b38d09b.svg";
export { ForwardRef as ReactComponent };